import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppRooute } from 'src/app/core/common/app-route.model';
import { AppSettings } from 'src/app/core/common/app-settings';
import { RouteConstant } from 'src/app/core/common/route-constant';
import { StateConstant } from 'src/app/core/common/state-constant';
import { OperacionEnum } from 'src/app/core/enums/operacion.enum';
import { GrupoService } from 'src/app/core/services/caso/grupo.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { GrupoSocioFormComponent } from '../../grupo/grupo-socio/grupo-socio-form/grupo-socio-form.component';
import { DisplayService } from 'src/app/core/services/caso/display.service';
import { MunicipioVo } from 'src/app/shared/models/caso/display/municipio-vo.model';
import { ConfigDto } from 'src/app/shared/models/caso/display/config-dto.model';
import { PublicacionService } from 'src/app/core/services/caso/publicacion.service';
import { NotificacionService } from 'src/app/core/services/caso/notificacion.service';

@Component({
  selector: 'vex-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.scss']
})
export class ConfigComponent implements OnInit {
  appSettings = AppSettings;
  stateConstant = StateConstant;
  crumbs: AppRooute[] = [RouteConstant.ROUTE_CONFIG];

  form1: FormGroup;
  form2: FormGroup;

  id: number;
  actionType: string;

  grupoService = inject(GrupoService);
  displayService = inject(DisplayService);
  publicacionService = inject(PublicacionService);
  notificacionService = inject(NotificacionService);

  dataSource: MatTableDataSource<MunicipioVo>;
  displayedColumns: string[] = ['departamento', 'municipio', 'estado', 'actions'];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  selection = new SelectionModel<MunicipioVo>(true, []);
  searchKey: string;

  dto: ConfigDto = new ConfigDto();

  constructor(private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private dialog: MatDialog,
    private fb: FormBuilder) {

    this.form1 = this.fb.group({
      notificacion: [true, Validators.required]
    });

    this.form2 = this.fb.group({
      inicial: [""],
      asunto: [""],
      saludo: [""],
      cuerpo: [""],
      despedida: [""],
      firma: [""]
    });
  }

  ngOnInit(): void {
    this.notificacionService.current()
      .subscribe(
        response => {
          this.form2.controls['inicial'].setValue(response.data.inicial);
          this.form2.controls['asunto'].setValue(response.data.asunto);
          this.form2.controls['saludo'].setValue(response.data.saludo);
          this.form2.controls['cuerpo'].setValue(response.data.cuerpo);
          this.form2.controls['despedida'].setValue(response.data.despedida);
          this.form2.controls['firma'].setValue(response.data.firma);

          this.form1.controls['notificacion'].setValue(response.data.notificacion);
        },
        err => {
          console.error('Código del error desde el backend: ' + err.status);
          console.error(err.error.errors);
        }
      );
  }

  loadList(): void {
    this.displayService.municipios().subscribe(
      response => {
        this.toastrService.success(response.message);
        this.dataSource = new MatTableDataSource(response.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      },
      err => {
        console.error(err);
      }
    );
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  nothing() { }

  save() {
    this.dto.inicial = this.form2.value.inicial;
    this.dto.asunto = this.form2.value.asunto;
    this.dto.saludo = this.form2.value.saludo;
    this.dto.cuerpo = this.form2.value.cuerpo;
    this.dto.despedida = this.form2.value.despedida;
    this.dto.firma = this.form2.value.firma;

    this.notificacionService.config(this.dto).subscribe(response => {
      if (response.status) {
        this.toastrService.success(response.message);
      } else
        this.toastrService.warning(response.message);
    });
  }

  updateStatus() {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: new ConfirmDialogModel("Cambiar Estado", "¿Está seguro de cambiar el estado de notificaciones?")
      })
      .afterClosed()
      .subscribe((confirmado: Boolean) => {
        if (confirmado) {
          this.notificacionService.cambiarEstado().subscribe(
            response => {
              if (response.status) {
                this.toastrService.success(response.message);
              } else {
                this.toastrService.warning(response.message);
              }
            },
            err => {
              this.toastrService.error(err.data);
            }
          )
        }
      });
  }

  agreeGrupoSocio() {
    const dialogRef = this.dialog.open(GrupoSocioFormComponent, {
      width: AppSettings.DIALOG_WIDTH,
      data: {
        operation: OperacionEnum.create,
        title: 'Agregar socio',
        button: AppSettings.DIALOG_BUTTON_PERSIST_POSITIVE,
        entity: this.id
      }
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.loadList();
      }
    });
  }
}
